export default "__VITE_ASSET__5AmMp3bU__"